// extracted by mini-css-extract-plugin
module.exports = {"panel":"DailyPlayersAtRisk_panel__1Hq-e"};